var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-25906a8f-0eda-4900-9f80-80781ecbe2d7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1197.39 468.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-54e33318-32bf-4c8a-9e15-54d4dc1037ce{fill:url(#uuid-540b15cd-f9da-404b-a4f2-11beffac9d91);}.uuid-54e33318-32bf-4c8a-9e15-54d4dc1037ce,.uuid-a4bbe967-77aa-480c-92cf-db216a5ec29d,.uuid-3aa14201-e34a-491d-ab3a-e25660fb9889{opacity:.99;}.uuid-a4bbe967-77aa-480c-92cf-db216a5ec29d{fill:url(#uuid-2eeb9295-cf38-403b-96b2-2a0f9ac82c9f);}.uuid-3aa14201-e34a-491d-ab3a-e25660fb9889{fill:url(#uuid-36b2bbd1-f2dc-4dfb-98ef-e608e82757c9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-36b2bbd1-f2dc-4dfb-98ef-e608e82757c9",
    x1: 4.9,
    y1: 239.08,
    x2: 1192.4,
    y2: 239.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5093fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9345fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd6afb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-2eeb9295-cf38-403b-96b2-2a0f9ac82c9f",
    x1: 39.56,
    y1: 54.32,
    x2: 296.03,
    y2: 310.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-540b15cd-f9da-404b-a4f2-11beffac9d91",
    x1: 1156.56,
    y1: 57.12,
    x2: 900.19,
    y2: 313.49,
    xlinkHref: "#uuid-2eeb9295-cf38-403b-96b2-2a0f9ac82c9f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-4ddc92b6-4b57-49de-be36-3fedefc878a0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-3aa14201-e34a-491d-ab3a-e25660fb9889",
    d: "m1078.64,9.83c-79.64,186.3-264.57,316.85-479.99,316.85S198.29,196.13,118.65,9.83L4.9,101.18c108.82,217.68,333.83,367.15,593.75,367.15s484.92-149.47,593.75-367.15l-113.76-91.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a4bbe967-77aa-480c-92cf-db216a5ec29d",
    d: "m115.47,0L0,93.88c54.87,111.1,138.81,204.92,241.75,271.2l88.15-115.95C234.96,191.25,159.42,104.09,115.47,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-54e33318-32bf-4c8a-9e15-54d4dc1037ce",
    d: "m1080.08,5.48l117.31,92.47c-55.74,109.44-141.03,201.85-245.62,267.13l-89.56-114.21c96.46-57,173.21-142.85,217.87-245.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBlur);
export default __webpack_public_path__ + "static/media/bottom-blur.01659515c6832de02180a5aa85d392ca.svg";
export { ForwardRef as ReactComponent };